module.exports = __webpack_public_path__ + "static/media/chevron_right.a1930aba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/chevron_right.svg
// module id = 49
// module chunks = 0